export default __webpack_public_path__ + "static/media/arrow.9682b0ce.svg";